import React from 'react';
import { JsonCmsContent, PluginType } from '../../types/JsonCmsContent';
import ContentSection from './Plugins/ContentSection';
import TeacherGuide from './Plugins/TeacherGuide';
import Text from './Plugins/Text';
import VerticalSpacer from './Plugins/VerticalSpacer';
import Picture from './Plugins/Picture';
import CodeBlock from './Plugins/CodeBlock';
import HighlightSection from './Plugins/HighlightSection';
import EditorBlock from './Plugins/EditorBlock';
import InteractiveQuiz from './Plugins/InteractiveQuiz';
import YoutubeEmbed from './Plugins/YoutubeEmbed';
import ConditionalBlock from './Plugins/ConditionalBlock';
import { StudyGroup } from '../../../app/hooks/api/types';
import FileBlock from './Plugins/FileBlock';
import PresentationBlock from './Plugins/PresentationBlock';
import AssessmentPluginBlock from './Plugins/AssessmentPluginBlock';
import InfobipPortalEmbedBlock from './Plugins/InfobipPortalEmbedBlock';
import TablePlugin from './Plugins/TablePlugin';
import EmbedBlock from './Plugins/EmbedBlock';
import ImageHotspots from './Plugins/ImageHotspots';
import Fill from './Plugins/Fill';
import MarkTheWords from './Plugins/MarkTheWords';
import Associations from './Plugins/Associations';
import FlipCard from './Plugins/FlipCard';
import StackLayout from './Plugins/StackLayout';
import GptBlock from './Plugins/GptBlock';
import HtmlBlock from './Plugins/HtmlBlock';
import ModalBlock from './Plugins/ModalBlock';
import AIBlock from './Plugins/AIBlock';
// import BlankPlugin from './Plugins/BlankPlugin';
import TriggerBlock from './Plugins/TriggerBlock';

export interface PluginProps {
  content: JsonCmsContent;
  isTeacherGuideDisplayed: boolean;
  studyGroup: StudyGroup;
  currentAssessmentQuestion: number;
  notes: any[];
  showExperimentalFeatures: boolean;
  showNoteTaking: boolean;
  createNote: (note: any) => void;
  updateNoteData: (noteId: string, noteData: any) => void;
  deleteNote: (noteId: string) => void;
  onComment: (noteId: string) => void;
  [x: string | number | symbol]: any;
}

const contentSpecificPlugins: Record<
  PluginType,
  (props: any) => JSX.Element | null
> = {
  [PluginType.ContentSectionPlugin]: ContentSection,
  [PluginType.TextPlugin]: Text,
  [PluginType.TeacherGuidePlugin]: TeacherGuide,
  [PluginType.VerticalSpacerPlugin]: VerticalSpacer,
  [PluginType.PicturePlugin]: Picture,
  [PluginType.CodeBlockPlugin]: CodeBlock,
  [PluginType.HighlightSectionPlugin]: HighlightSection,
  [PluginType.EditorBlockPlugin]: EditorBlock,
  [PluginType.InteractiveQuizPlugin]: InteractiveQuiz,
  [PluginType.YoutubeEmbedPlugin]: YoutubeEmbed,
  [PluginType.ConditionalBlockPlugin]: ConditionalBlock,
  [PluginType.FileBlockPlugin]: FileBlock,
  [PluginType.PresentationBlockPlugin]: PresentationBlock,
  [PluginType.AssessmentPlugin]: AssessmentPluginBlock,
  [PluginType.InfobipPortalEmbedPlugin]: InfobipPortalEmbedBlock,
  [PluginType.TablePlugin]: TablePlugin,
  [PluginType.GoogleDrivePlugin]: EmbedBlock,
  [PluginType.EmbedBlockPlugin]: EmbedBlock,
  [PluginType.ImageHotspotsPlugin]: ImageHotspots,
  [PluginType.FillPlugin]: Fill,
  [PluginType.MarkTheWordsPlugin]: MarkTheWords,
  [PluginType.AssociationsPlugin]: Associations,
  [PluginType.FlipCardPlugin]: FlipCard,
  [PluginType.StackLayoutPlugin]: StackLayout,
  [PluginType.GptBlockPlugin]: GptBlock,
  [PluginType.AIBlockPlugin]: AIBlock,
  [PluginType.HtmlBlockPlugin]: HtmlBlock,
  [PluginType.ModalBlockPlugin]: ModalBlock,
  [PluginType.TriggerBlockPlugin]: TriggerBlock,
};

const Plugin = (props: PluginProps) => {
  const { content } = props;

  if (!props.content?.plugin) {
    return null;
  }
  const ContentSpecificPlugin = contentSpecificPlugins[props.content.plugin];

  if (ContentSpecificPlugin) {
    return <ContentSpecificPlugin key={content.id} {...props} />;
  }

  return <div>{content.plugin}</div>;
};

export default Plugin;
